




































import { Component, Mixins } from 'vue-property-decorator'
import { toArray } from 'lodash'

import { getPosition } from '@utils/index'
import { RECOVERYCATEGORY } from '../category.config'
import { LoadList } from '@shared/mixins/loadList'
import {
  queryCityAndLevel4CategorySpus,
  queryBusinessAndSpuList,
} from '../category.service'
import { SuperMixin } from '../category.mixin'

//import SelfOperatedComponent from '../components/selfOperated/selfOperated.vue'
import TabSelectComponent from '../components/tabSelect/tabSelect.vue'
//import RecoveryComponent from '../components/recovery/recovery.vue'
import TentantComponent from '../components/tentant/tentant.vue'
import GoodsComponent from '../components/goods/goods.vue'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

@Component({
  components: {
    SelfOperatedComponent: () => import('../components/selfOperated/selfOperated.vue'),
    TabSelectComponent,
    RecoveryComponent: () => import('../components/recovery/recovery.vue'),
    TentantComponent,
    GoodsComponent,
  },
})
export default class CommonComponent extends Mixins(LoadList, SuperMixin) {
  confition: any = null // 条件
  hasRecovery = false //产后恢复品类才有
  hasConfition = false // 当前城市下有条件
  position: any = null
  isTentant = true //是商户
  selfOperatedData: any = null
  @categoryModule.Action getSelfOperatedData!: (payload: any) => Promise<any>


  get showAllEmpty() {
    return (
      !this.hasConfition &&
      !this.result.loading &&
      this.selfOperatedData &&
      this.selfOperatedData.worker &&
      this.selfOperatedData.worker.length === 0 && this.selfOperatedData.spuList && this.selfOperatedData.spuList.length === 0
    )
  }

  async created() {
    this.hasRecovery = this.categoryId == RECOVERYCATEGORY
    this.getPosition()
  }
  async getPosition() {
    this.result.loading = true
    this.position = await getPosition()
    if (!this.hasRecovery) {
      this.selfOperatedData = await this.getSelfOperatedData({
        positon: this.position,
        categoryId: this.categoryId,
      })
    } else {
      this.selfOperatedData = {
        spuList: [],
        nearStore: null,
        worker: []
      }
    }
    this.getList()
  }
  changeCondition(confition: any) {
    if (!this.confition) {
      this.confition = confition
    } else {
      this.setInitResult()
      this.confition = confition
      this.getList()
    }
  }
  onLoad() {
    this.getList()
  }
  async getList() {
    let {
      // categoryId,
      // districtId,
      // other,
      tabCut,
    } = this.confition
    const pageIndex = ++this.result.pageIndex
    const pageSize = this.result.pageSize

    this.result.loading = true
    let response
    if (tabCut == 1) {
      //商户
      //console.log(this.confition, this.position, '====>获取商户列表')
      this.isTentant = true
      response = await queryBusinessAndSpuList({
        ...this.position,
        ...this.confition,
        pageIndex,
        pageSize,
        allCategoryIds: this.categoryIds
      })
      if (pageIndex === 1) {
        this.hasConfition = !!response.cityHasBusiness //是否有商户
      }
    } else if (tabCut == 2) {
      //商品
      //console.log(this.confition, this.position, '====>获取商品列表')
      this.isTentant = false
      response = await queryCityAndLevel4CategorySpus({
        ...this.position,
        ...this.confition,
        pageIndex,
        pageSize,
      })
    }
    if (pageIndex === 1) {
      this.result.list = []
    }
    this.result.loading = false
    if (response && response.code * 1 === 1) {
      const list: any[] = toArray(response.data)
      this.result.list = this.result.list.concat(list)
      if (list.length < this.result.pageSize) {
        this.result.finished = true
      }
    } else {
      --this.result.pageIndex
      this.result.error = true
    }
  }
}
